<script lang="ts">
  import { Popper, type Align } from "#lib/components/ui/popper/index"
  import { getUiclContext } from "#lib/internal/helpers/uiclContext"
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import { getSelectRootContext } from "./SelectRoot.svelte"

  type Props = BaseProps<"dialog"> & {
    width?: string
    minWidth?: string
    align?: Align
    children?: Snippet
    listbox?: Snippet
  }

  let {
    width = "",
    minWidth = "",
    align = undefined,
    children,
    listbox,
    ...restProps
  }: Props = $props()

  let ref: HTMLElement | null = $state(null)

  const useV2Styling = !!getUiclContext()?.v2
  const rootCtx = getSelectRootContext()

  $effect(() => {
    if (ref) rootCtx.panelRef = ref
  })
</script>

<Popper.Content
  bind:ref
  data-state={rootCtx.open ? "open" : "closed"}
  {...restProps as any}
  class={cn(
    "shadow-bottom-100 max-h-64 overflow-auto bg-transparent",
    {
      "z-10": rootCtx.open,
      hidden: !rootCtx.open || rootCtx.options.length === 0,
    },
    useV2Styling
      ? "border-general-neutral-02 bg-general-surface-02-deepest mt-0.5 rounded border"
      : "data-[side=bottom]:rounded-b data-[side=top]:rounded-t",
    restProps.class
  )}
  {width}
  {minWidth}
  {align}
>
  <!-- TODO: extract list box -->
  {#if listbox}
    {@render listbox()}
  {:else}
    <ul
      aria-multiselectable={rootCtx.multiselect}
      class="max-w-full overflow-x-hidden outline-hidden"
      role="listbox"
      id="{rootCtx.idPrefix}-panel"
    >
      {@render children?.()}
    </ul>
  {/if}
</Popper.Content>
